/* src/app/weighbridge/pages/weighbridge-yard-trade-customer/weighbridge-yard-trade-customer.component.scss */
/*# sourceMappingURL=weighbridge-yard-trade-customer.component.css.map */
